<template>
    <div class="report-grade selectbox-question">
        <div class="title">
            <slot name="title"></slot>
            <span class="total-answers"
                >{{ groupValuesTotal }} {{ $root.t('forms-report_component-answers') }} |
                <span
                    class="dropdown-toggle"
                    id="view-mode"
                    data-toggle="dropdown"
                >
                    {{ $root.t('forms-report_component-selectbox_view') }}
                    <u>{{ viewMode === "list" ? $root.t('forms-report_component-selectbox_list') : $root.t('forms-report_component-selectbox_chart') }}</u>
                </span>
                <div class="dropdown-menu" aria-labelledby="view-mode">
                    <a
                        class="dropdown-item"
                        v-show="viewMode !== 'list'"
                        @click.prevent="viewMode = 'list'"
                        href="#"
                        >{{ $root.t('forms-report_component-selectbox_list') }}</a
                    >
                    <a
                        class="dropdown-item"
                        v-show="viewMode !== 'pie'"
                        @click.prevent="viewMode = 'pie'"
                        href="#"
                        >{{ $root.t('forms-report_component-selectbox_chart') }}</a
                    >
                </div>
            </span>
        </div>
        <div class="distribuition" v-if="hasAnswers">
            <template v-if="viewMode === 'list'">
                <div
                    v-for="(value, i) in groupValues"
                    :key="i"
                    class="distribuition-row"
                >
                    <span class="label" for="">{{ value.label }}</span>
                    <div class="bar">
                        <div
                            class="inside-bar"
                            v-bind:style="{
                                width: gradesNumberToPercent(value.count) + '%',
                            }"
                        ></div>
                    </div>
                    <div class="percent">{{ value.count }}</div>
                </div>
            </template>
            <template v-if="viewMode === 'pie'">
                <pie-chart :chart-data="pieCustomerChartData" :height="158" />
            </template>
        </div>
        <div class="no-answers" v-if="!hasAnswers">
            {{ $root.t('forms-report_component-no_answers') }}
        </div>
    </div>
</template>
<script>
import MathHelper from "./../../helpers/Math";
export default {
    props: {
        answers: Array,
        gradeClassMethod: Function,
    },
    data: function () {
        return {
            viewMode: "list",
        };
    },
    computed: {
        grades() {
            let grades = [];
            for (let a in this.answers) {
                let answer = this.answers[a];
                if (this.useGrade) {
                    grades.push(answer.grade);
                } else {
                    grades.push(answer.valueNumber);
                }
            }
            return grades;
        },
        hasAnswers() {
            return this.answers.length > 0;
        },
        groupValues() {
            let values = {};
            this.answers.forEach((answer) => {
                let answerValue = answer.value;
                if (!Array.isArray(answerValue)) {
                    console.log("answerValue", answer);
                    answerValue = JSON.parse(`${answer.value}`);
                }

                answerValue.forEach((value) => {
                    if (values[value] === undefined) {
                        values[value] = 1;
                    } else {
                        values[value] += 1;
                    }
                });
            });
            let valuesArray = [];
            for (let value in values) {
                valuesArray.push({ label: value, count: values[value] });
            }
            valuesArray.sort((a, b) => b.count - a.count);
            return valuesArray;
        },
        groupValuesTotal() {
            return this.groupValues
                .map((v) => v.count)
                .reduce((a, b) => a + b, 0);
        },
        filterAnswers() {
            return this.answers
                .map((a) => JSON.parse(a.valueText))
                .map((v) => v.join(", "));
        },
        gradeClass: function () {
            return this.gradeClassMethod;
        },
        average: function () {
            var sum = 0;
            for (var i = 0; i < this.groupValuesTotal; i++) {
                sum += this.round(this.groupValuesTotal);
            }
            var avg = sum / this.groupValuesTotal;
            return this.round(avg, 1);
        },
        pieCustomerChartData() {
            return {
                labels: this.groupValues.map((g) => g.label),
                datasets: [
                    {
                        data: this.groupValues.map((g) => g.count),
                        backgroundColor: [
                            "#A7CCC0",
                            "#00542E",
                            "#7ee3db",
                            "#74d6a3",
                            "#ff8c22",
                            "#ff7b7b",
                            "#ffc107",
                        ],
                    },
                ],
            };
        },
    },
    methods: {
        gradesNumberToPercent: function (number) {
            return (number / this.groupValuesTotal) * 100;
        },
        round: MathHelper.round,
    },
};
</script>
